/**
 * Get the backend URL based on the current environment
 * 
 * For production (onsitehand.co.uk): Uses the same origin (API is on same domain)
 * For preview/development: Uses REACT_APP_BACKEND_URL from .env
 */

const getBackendUrl = () => {
  // Check if we're on the production domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domains - API is on the same origin
    if (hostname === 'onsitehand.co.uk' || hostname === 'www.onsitehand.co.uk') {
      return window.location.origin;
    }
  }
  
  // Development/preview - use the env variable
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();
export default BACKEND_URL;
